import { Pipe, PipeTransform } from '@angular/core';
import {AttributeEntity, AttributeEntityItem} from '../../model/integration-models';
import {RestrictionFilter} from '@app/core/model/filtering/restriction-filter';

@Pipe({
    name: 'ngcFilterAllowedEntityAttributes'
})
export class FilterAllowedEntityAttributesPipe implements PipeTransform {

    transform(attributeEntity: AttributeEntity, row: RestrictionFilter, isMostUsedInSearch: boolean = null): AttributeEntityItem[] {
        let attributes = attributeEntity ? attributeEntity.attributes : [];
        attributes = attributes.filter((attr: AttributeEntityItem) =>
            attr.isAllowedForSearch && ((isMostUsedInSearch === null) || (isMostUsedInSearch === attr.isMostUsedInSearch))
                && attr.propertyName !== 'districtId'
        );
        if (isMostUsedInSearch) {
            attributes.sort((a: AttributeEntityItem, b: AttributeEntityItem) => a.order - b.order);
        }
        return attributes;


    }

}
